var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigmaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 65C130 100.899 100.899 130 65 130C29.1015 130 0 100.899 0 65C0 29.1015 29.1015 0 65 0C100.899 0 130 29.1015 130 65Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.75 56.25C86.3967 56.25 89.8941 54.8013 92.4727 52.2227C95.0513 49.6441 96.5 46.1467 96.5 42.5C96.5 38.8533 95.0513 35.3559 92.4727 32.7773C89.8941 30.1987 86.3967 28.75 82.75 28.75H55.25C51.6033 28.75 48.1059 30.1987 45.5273 32.7773C42.9487 35.3559 41.5 38.8533 41.5 42.5C41.5 46.1467 42.9487 49.6441 45.5273 52.2227C48.1059 54.8013 51.6033 56.25 55.25 56.25C51.6033 56.25 48.1059 57.6987 45.5273 60.2773C42.9487 62.8559 41.5 66.3533 41.5 70C41.5 73.6467 42.9487 77.1441 45.5273 79.7227C48.1059 82.3013 51.6033 83.75 55.25 83.75C52.5305 83.75 49.8721 84.5564 47.6109 86.0673C45.3497 87.5782 43.5874 89.7256 42.5467 92.2381C41.506 94.7506 41.2337 97.5153 41.7642 100.182C42.2948 102.85 43.6043 105.3 45.5273 107.223C47.4503 109.146 49.9003 110.455 52.5675 110.986C55.2348 111.516 57.9994 111.244 60.5119 110.203C63.0244 109.163 65.1718 107.4 66.6827 105.139C68.1936 102.878 69 100.219 69 97.5V56.25H82.75Z",
    fill: "#1B1B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.75 83.75C90.3439 83.75 96.5 77.5939 96.5 70C96.5 62.4061 90.3439 56.25 82.75 56.25C75.1561 56.25 69 62.4061 69 70C69 77.5939 75.1561 83.75 82.75 83.75Z",
    fill: "#1B1B1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/figma-logo.92d2b59142d412a90bb4eac3cf5c97cf.svg";
export { ForwardRef as ReactComponent };